import {z} from 'zod';
import {defineToolRegistryManifest} from '../../../types/base-tool-types';

const toolName = 'get-site-recommendation' as const;

const argumentZod = z.object({
  siteId: z.string().describe('The site ID the recommendation belongs to'),
  recommendationId: z.string().describe('The recommendation ID to retrieve'),
});

export const getSiteRecommendationManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get site recommendation',
  family: 'recommendations',
  llmTool: {
    name: toolName,
    description:
      'Gets a single site recommendation by ID. Returns the full recommendation object including status, proposal, action, priority, and all metadata.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SiteAeoRecommendations',
      action: 'read',
      resolveResources: (args) => [
        {type: 'SiteAeoRecommendations', id: args.siteId},
      ],
    },
  ],
  confirmBeforeExecuting: false,
});

export type GetSiteRecommendationArgumentType = z.infer<typeof argumentZod>;
